module.exports = __webpack_public_path__ + "static/media/preplay-up-arrow-black.769bfdcf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-up-arrow-black.webp
// module id = ./src/assets/images/preplay-up-arrow-black.webp
// module chunks = 0